import React, {useState} from "react";
import { Dropdown } from "react-bootstrap";
import style from "./DropdownBtn.module.css";
import { FaChevronDown, FaStar } from "react-icons/fa";
import { UpgradeToProModal } from "../UpgradeToProModal";

const DropdownBtn = ({
  variant,
  id,
  title,
  disabled,
  children,
  drop,
  customClass,
  align,
  filterDropdownBtn,
  showDropdown,
  handleApplyFilters,
  toggleDropdown,
  insertModal,
  userPro,
}) => {
  const [showProVersionModal, setShowProVersionModal] = useState(false);

  const handleShowProVersionModal = () => {
    setShowProVersionModal(true);
  }

  return (
    <>
      <Dropdown
        drop={drop}
        align={align}
        show={filterDropdownBtn ? showDropdown : undefined}
        onToggle={filterDropdownBtn && !insertModal ? toggleDropdown : insertModal && userPro ? toggleDropdown : !userPro ? handleShowProVersionModal : undefined}
      >
        <Dropdown.Toggle
          id={id}
          variant={variant}
          disabled={disabled}
          className={`${customClass} no-default-icon`}
        >
          {title} {insertModal && !userPro && <FaStar color="#FF6563" style={{ marginLeft: ".3rem" }} />}
          <FaChevronDown />
        </Dropdown.Toggle>
        <Dropdown.Menu className={style.dropdownMenu}>{children}</Dropdown.Menu>
      </Dropdown>
      <UpgradeToProModal
        setShowProVersionModal={setShowProVersionModal}
        showProVersionModal={showProVersionModal}
      />
    </>
  );
};

export default DropdownBtn;
